import { useQuery } from '@apollo/client';
import {
  type RiskAssessmentResultConfig,
  riskAssessmentResultConfigSchema,
} from '@risksmart-app/domain/src/types';
import { GetLatestRiskAssessmentResultConfigDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import type { ConfigType } from './types';

export type { RiskAssessmentResultConfig };
export { riskAssessmentResultConfigSchema };

export const useGetLatestRiskAssessmentResultConfig = (options: {
  type: ConfigType;
  skip?: boolean;
}) => {
  const { data, loading, error, refetch } = useQuery(
    GetLatestRiskAssessmentResultConfigDocument,
    { variables: { Type: options.type }, skip: options.skip }
  );

  const record = data?.risk_assessment_result_config[0];
  const config = record?.Config
    ? riskAssessmentResultConfigSchema.parse(record.Config)
    : undefined;

  return {
    config,
    loading,
    error,
    id: record?.Id,
    originalTimestamp: record?.ModifiedAtTimestamp,
    refetch,
  };
};
